import type { Theme } from '@/types/global.types'

/**
 * Retrieves the theme settings from the HTML element with the id "themeSettings",
 * and returns them as a JavaScript object.
 *
 * @returns {object} The theme settings as a JavaScript object.
 */
export function getThemeSettings(): Theme {
  const themeSettings = document.querySelector('#themeSettings')?.textContent
  return JSON.parse(themeSettings || '{}')
}

export function getAppVersion(): string | null | undefined {
  return document.querySelector('#appVersion')?.textContent
}

/**
 * Retrieves the localized value for a given key from the theme settings.
 * If the locale-specific value is not found, returns the key itself.
 *
 * @param {string} key - The key to look up in the localized settings.
 * @returns {string} The localized value for the given key, or the key itself if not found.
 */
export function i18n(key: string) {
  const themeSettings = getThemeSettings()
  return themeSettings?.i18n?.[key] || key
}

/**
 * Retrieves the dashboard modules from the theme settings.
 * @returns {Array} An array of dashboard modules.
 */

export function getDashboardModules() {
  const themeSettings = getThemeSettings()
  return themeSettings?.dashboard || []
}

export function getFormats() {
  const themeSettings = getThemeSettings()
  return themeSettings?.silos || []
}
